/**
 * 配車計画 ドライバー配車 運搬統合
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/drivers`

 const allocate_entry_driver_destination = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    update({ commit }, { driver_id, params }) {
      const api_path = `${API_PATH}/${driver_id}/destinations`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { driver_id, manifest_id, target_date }) {
      const api_path = `${API_PATH}/${driver_id}/schedules/${manifest_id}`
      const params = { target_date: target_date }
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path, { params: params }).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_driver_destination
